<div class="inline-flex text-sm font-bold uppercase">
  {{ reason() | subscriptionSuspendReason | async }}
</div>
